import eventMixin from '../lib/eventMixin';
import Logger from "../utilities/Logger";
import Player from '@vimeo/player';

const classes = {
	open : 'theme-media-lightbox--open'
}

const videoContainerDataAttribute = 'data-theme-media-lightbox-video-container';
const videoElementDataAttribute = 'data-theme-media-lightbox-video';

export default class ThemeMediaLightboxVideo {

	static generateHtml(vimeoId) {
		const dom = document.createElement('div');
		dom.classList.add('theme-media-lightbox__video-container');
		dom.setAttribute(videoContainerDataAttribute, vimeoId);
		dom.setAttribute('data-theme-media-lightbox-close', true);

		const videoDom = document.createElement('div');
		videoDom.classList.add('theme-media-lightbox__video');
		videoDom.setAttribute(videoElementDataAttribute, "");
		dom.appendChild(videoDom);

		return dom;
	}

	constructor(dom) {
		Logger.info('ThemeMediaLightboxVideo: initializing...');

		this.dom = dom;
		this.videoElement = this.dom.querySelector(`[${videoElementDataAttribute}]`);
		this.videoPlayer = null;
		this.vimeoId = dom.getAttribute(videoContainerDataAttribute);
	}

	createVideoPlayer() {

		if(!this.videoPlayer) {
			const options = {
		    	id: this.vimeoId,
	        autoplay: false,
	        responsive: true,
	        width: 640,
	        loop: true
	    };
			this.videoPlayer = new Player(this.videoElement, options);
	    this.videoPlayer.on('load', function() {
        console.log('New video was loaded...');
	    });

	    this.videoPlayer.on('playing', function() {
        console.log('Video is playing...');
	    });

	    return;
		}

		this.videoPlayer.loadVideo(vimeoId).then(function(id) {
			self.videoPlayer.play();
		}).catch(function(error) {
			console.error(error);
		});

	}

	// Called by ThemeMediaLightbox
	destroy() {
		if(this.videoPlayer) {
			this.videoPlayer.destroy();
			this.videoPlayer = null;
		}
	}

	// Called by ThemeMediaLightbox
	init() {
		this.createVideoPlayer();
	}

  // Pause the video player
  pause() {
    this.videoPlayer?.pause();
  }
}

// Mixins
Object.assign(ThemeMediaLightboxVideo.prototype, eventMixin);
